/* RESPONSIBLE TEAM: team-frontend-tech */
/* eslint-disable @intercom/intercom/no-bare-strings */
export const IOS_DEVICES: {
  label: string;
  value: string;
  group: 'Products' | 'Capability' | 'Models';
}[] = [
  {
    label: 'iPad',
    value: 'ipad',
    group: 'Products',
  },
  {
    label: 'iPhone',
    value: 'iphone',
    group: 'Products',
  },
  {
    label: 'iPod Touch',
    value: 'ipod-touch',
    group: 'Products',
  },
  {
    label: 'Retina',
    value: 'retina',
    group: 'Capability',
  },
  {
    label: 'Non-Retina',
    value: 'non-retina',
    group: 'Capability',
  },
  {
    label: 'iPad Mini',
    value: 'ipad-mini',
    group: 'Models',
  },
  {
    label: 'iPad Mini 2',
    value: 'ipad-mini-2',
    group: 'Models',
  },
  {
    label: 'iPad Mini 3',
    value: 'ipad-mini-3',
    group: 'Models',
  },
  {
    label: 'iPad Mini 4',
    value: 'ipad-mini-4',
    group: 'Models',
  },
  {
    label: 'iPad Mini 5',
    value: 'ipad-mini-5th-gen',
    group: 'Models',
  },
  {
    label: 'iPad Mini 6',
    value: 'ipad-mini-6th-gen',
    group: 'Models',
  },
  {
    label: 'iPad',
    value: 'ipad-1',
    group: 'Models',
  },
  {
    label: 'iPad 2',
    value: 'ipad-2',
    group: 'Models',
  },
  {
    label: 'Retina iPad',
    value: 'ipad-3',
    group: 'Models',
  },
  {
    label: 'iPad (5th Generation)',
    value: 'ipad-5th-gen',
    group: 'Models',
  },
  {
    label: 'iPad (6th Generation)',
    value: 'ipad-6th-gen',
    group: 'Models',
  },
  {
    label: 'iPad (7th Generation)',
    value: 'ipad-7th-gen',
    group: 'Models',
  },
  {
    label: 'iPad (8th Generation)',
    value: 'ipad-8th-gen',
    group: 'Models',
  },
  {
    label: 'iPad (9th Generation)',
    value: 'ipad-9th-gen',
    group: 'Models',
  },
  {
    label: 'iPad (10th Generation)',
    value: 'ipad-10th-gen',
    group: 'Models',
  },
  {
    label: 'iPad Air',
    value: 'ipad-4',
    group: 'Models',
  },
  {
    label: 'iPad Air 2',
    value: 'ipad-5',
    group: 'Models',
  },
  {
    label: 'iPad Air (3rd Generation)',
    value: 'ipad-air-3rd-gen',
    group: 'Models',
  },
  {
    label: 'iPad Air (4th Generation)',
    value: 'ipad-air-4th-gen',
    group: 'Models',
  },
  {
    label: 'iPad Air (5th Generation)',
    value: 'ipad-air-5th-gen',
    group: 'Models',
  },
  {
    label: 'iPad Air (6th Generation)',
    value: 'ipad-air-6th-gen',
    group: 'Models',
  },
  {
    label: 'iPad Air (7th Generation)',
    value: 'ipad-air-7th-gen',
    group: 'Models',
  },
  {
    label: 'iPad Pro',
    value: 'ipad-pro',
    group: 'Models',
  },
  {
    label: 'iPad Pro 12.9" (2nd Generation)',
    value: 'ipad-pro-2',
    group: 'Models',
  },
  {
    label: 'iPad Pro 11"',
    value: 'ipad-pro-11',
    group: 'Models',
  },
  {
    label: 'iPad Pro 12.9" (3rd Generation)',
    value: 'ipad-pro-3rd-gen',
    group: 'Models',
  },
  {
    label: 'iPad Pro 11" (2nd Generation)',
    value: 'ipad-pro-11-2nd-gen',
    group: 'Models',
  },
  {
    label: 'iPad Pro 11" (3rd Generation)',
    value: 'ipad-pro-11-3rd-gen',
    group: 'Models',
  },
  {
    label: 'iPad Pro 12.9" (4th Generation)',
    value: 'ipad-pro-4th-gen',
    group: 'Models',
  },
  {
    label: 'iPad Pro 12.9" (5th Generation)',
    value: 'ipad-pro-5th-gen',
    group: 'Models',
  },
  {
    label: 'iPad Pro (6th Generation)',
    value: 'ipad-pro-6th-gen',
    group: 'Models',
  },
  {
    label: 'iPad Pro (7th Generation)',
    value: 'ipad-pro-7th-gen',
    group: 'Models',
  },
  {
    label: 'iPhone 3GS',
    value: 'iphone-3gs',
    group: 'Models',
  },
  {
    label: 'iPhone 4',
    value: 'iphone-4',
    group: 'Models',
  },
  {
    label: 'iPhone 4S',
    value: 'iphone-4s',
    group: 'Models',
  },
  {
    label: 'iPhone 5',
    value: 'iphone-5',
    group: 'Models',
  },
  {
    label: 'iPhone 5c',
    value: 'iphone-5c',
    group: 'Models',
  },
  {
    label: 'iPhone 5s',
    value: 'iphone-5s',
    group: 'Models',
  },
  {
    label: 'iPhone 6',
    value: 'iphone-6',
    group: 'Models',
  },
  {
    label: 'iPhone 6 Plus',
    value: 'iphone-6-plus',
    group: 'Models',
  },
  {
    label: 'iPhone 6s',
    value: 'iphone-6s',
    group: 'Models',
  },
  {
    label: 'iPhone 6s Plus',
    value: 'iphone-6s-plus',
    group: 'Models',
  },
  {
    label: 'iPhone SE',
    value: 'iphone-se',
    group: 'Models',
  },
  {
    label: 'iPhone 7',
    value: 'iphone-7',
    group: 'Models',
  },
  {
    label: 'iPhone 7 Plus',
    value: 'iphone-7-plus',
    group: 'Models',
  },
  {
    label: 'iPhone 8',
    value: 'iphone-8',
    group: 'Models',
  },
  {
    label: 'iPhone 8 Plus',
    value: 'iphone-8-plus',
    group: 'Models',
  },
  {
    label: 'iPhone X',
    value: 'iphone-x',
    group: 'Models',
  },
  {
    label: 'iPhone XS',
    value: 'iphone-xs',
    group: 'Models',
  },
  {
    label: 'iPhone XS Max',
    value: 'iphone-xs-max',
    group: 'Models',
  },
  {
    label: 'iPhone XR',
    value: 'iphone-xr',
    group: 'Models',
  },
  {
    label: 'iPhone 11',
    value: 'iphone-11',
    group: 'Models',
  },
  {
    label: 'iPhone 11 Pro',
    value: 'iphone-11-pro',
    group: 'Models',
  },
  {
    label: 'iPhone 11 Pro Max',
    value: 'iphone-11-pro-max',
    group: 'Models',
  },
  {
    label: 'iPhone 12',
    value: 'iphone-12',
    group: 'Models',
  },
  {
    label: 'iPhone 12 Pro',
    value: 'iphone-12-pro',
    group: 'Models',
  },
  {
    label: 'iPhone 12 Pro Max',
    value: 'iphone-12-pro-max',
    group: 'Models',
  },
  {
    label: 'iPhone 12 Mini',
    value: 'iphone-12-mini',
    group: 'Models',
  },
  {
    label: 'iPhone 13',
    value: 'iphone-13',
    group: 'Models',
  },
  {
    label: 'iPhone 13 Pro',
    value: 'iphone-13-pro',
    group: 'Models',
  },
  {
    label: 'iPhone 13 Pro Max',
    value: 'iphone-13-pro-max',
    group: 'Models',
  },
  {
    label: 'iPhone 13 Mini',
    value: 'iphone-13-mini',
    group: 'Models',
  },
  {
    label: 'iPhone 14',
    value: 'iphone-14',
    group: 'Models',
  },
  {
    label: 'iPhone 14 Pro',
    value: 'iphone-14-pro',
    group: 'Models',
  },
  {
    label: 'iPhone 14 Pro Max',
    value: 'iphone-14-pro-max',
    group: 'Models',
  },
  {
    label: 'iPhone 14 Plus',
    value: 'iphone-14-plus',
    group: 'Models',
  },
  {
    label: 'iPhone 15',
    value: 'iphone-15',
    group: 'Models',
  },
  {
    label: 'iPhone 15 Pro',
    value: 'iphone-15-pro',
    group: 'Models',
  },
  {
    label: 'iPhone 15 Pro Max',
    value: 'iphone-15-pro-max',
    group: 'Models',
  },
  {
    label: 'iPhone 15 Plus',
    value: 'iphone-15-plus',
    group: 'Models',
  },
  {
    label: 'iPhone 16',
    value: 'iphone-16',
    group: 'Models',
  },
  {
    label: 'iPhone 16 Pro',
    value: 'iphone-16-pro',
    group: 'Models',
  },
  {
    label: 'iPhone 16 Pro Max',
    value: 'iphone-16-pro-max',
    group: 'Models',
  },
  {
    label: 'iPhone 16 Plus',
    value: 'iphone-16-plus',
    group: 'Models',
  },
  {
    label: 'iPhone SE (2nd Generation)',
    value: 'iphone-se-2',
    group: 'Models',
  },
  {
    label: 'iPod Touch (4th Generation)',
    value: 'ipod-touch-4',
    group: 'Models',
  },
  {
    label: 'iPod Touch (5th Generation)',
    value: 'ipod-touch-5',
    group: 'Models',
  },
  {
    label: 'iPod Touch (6th Generation)',
    value: 'ipod-touch-6',
    group: 'Models',
  },
  {
    label: 'iPod Touch (7th Generation)',
    value: 'ipod-touch-7',
    group: 'Models',
  },
  {
    label: 'Simulator',
    value: 'simulator',
    group: 'Models',
  },
];

export const IOS_VERSIONS: { label: string; value: string }[] = [
  { label: '5.1', value: '5.1' },
  { label: '5.1.1', value: '5.1.1' },
  { label: '6.0', value: '6.0' },
  { label: '6.0.1', value: '6.0.1' },
  { label: '6.0.2', value: '6.0.2' },
  { label: '6.1', value: '6.1' },
  { label: '6.1.1', value: '6.1.1' },
  { label: '6.1.2', value: '6.1.2' },
  { label: '6.1.3', value: '6.1.3' },
  { label: '6.1.4', value: '6.1.4' },
  { label: '6.1.6', value: '6.1.6' },
  { label: '7.0', value: '7.0' },
  { label: '7.0.1', value: '7.0.1' },
  { label: '7.0.2', value: '7.0.2' },
  { label: '7.0.3', value: '7.0.3' },
  { label: '7.0.4', value: '7.0.4' },
  { label: '7.0.5', value: '7.0.5' },
  { label: '7.0.6', value: '7.0.6' },
  { label: '7.1', value: '7.1' },
  { label: '7.1.1', value: '7.1.1' },
  { label: '7.1.2', value: '7.1.2' },
  { label: '8.0', value: '8.0' },
  { label: '8.0.1', value: '8.0.1' },
  { label: '8.0.2', value: '8.0.2' },
  { label: '8.1.1', value: '8.1.1' },
  { label: '8.1.2', value: '8.1.2' },
  { label: '8.1.3', value: '8.1.3' },
  { label: '8.2', value: '8.2' },
  { label: '8.3', value: '8.3' },
  { label: '8.4', value: '8.4' },
  { label: '8.4.1', value: '8.4.1' },
  { label: '9.0', value: '9.0' },
  { label: '9.0.1', value: '9.0.1' },
  { label: '9.0.2', value: '9.0.2' },
  { label: '9.1', value: '9.1' },
  { label: '9.2', value: '9.2' },
  { label: '9.2.1', value: '9.2.1' },
  { label: '9.3', value: '9.3' },
  { label: '9.3.1', value: '9.3.1' },
  { label: '9.3.2', value: '9.3.2' },
  { label: '9.3.3', value: '9.3.3' },
  { label: '9.3.4', value: '9.3.4' },
  { label: '9.3.5', value: '9.3.5' },
  { label: '10.0', value: '10.0' },
  { label: '10.0.1', value: '10.0.1' },
  { label: '10.0.2', value: '10.0.2' },
  { label: '10.1', value: '10.1' },
  { label: '10.1.1', value: '10.1.1' },
  { label: '10.2', value: '10.2' },
  { label: '10.2.1', value: '10.2.1' },
  { label: '10.3', value: '10.3' },
  { label: '10.3.1', value: '10.3.1' },
  { label: '10.3.2', value: '10.3.2' },
  { label: '10.3.3', value: '10.3.3' },
  { label: '11.0', value: '11.0' },
  { label: '11.0.1', value: '11.0.1' },
  { label: '11.0.2', value: '11.0.2' },
  { label: '11.0.3', value: '11.0.3' },
  { label: '11.1', value: '11.1' },
  { label: '11.1.1', value: '11.1.1' },
  { label: '11.2', value: '11.2' },
  { label: '11.2.6', value: '11.2.6' },
  { label: '11.3', value: '11.3' },
  { label: '11.3.1', value: '11.3.1' },
  { label: '11.4', value: '11.4' },
  { label: '11.4.1', value: '11.4.1' },
  { label: '12.0', value: '12.0' },
  { label: '12.0.1', value: '12.0.1' },
  { label: '12.1', value: '12.1' },
  { label: '12.1.1', value: '12.1.1' },
  { label: '12.1.2', value: '12.1.2' },
  { label: '12.1.3', value: '12.1.3' },
  { label: '12.1.4', value: '12.1.4' },
  { label: '12.2', value: '12.2' },
  { label: '12.3', value: '12.3' },
  { label: '12.3.1', value: '12.3.1' },
  { label: '12.3.2', value: '12.3.2' },
  { label: '12.4', value: '12.4' },
  { label: '12.4.1', value: '12.4.1' },
  { label: '12.4.2', value: '12.4.2' },
  { label: '12.4.3', value: '12.4.3' },
  { label: '13.0', value: '13.0' },
  { label: '13.1', value: '13.1' },
  { label: '13.1.1', value: '13.1.1' },
  { label: '13.1.2', value: '13.1.2' },
  { label: '13.1.3', value: '13.1.3' },
  { label: '13.2', value: '13.2' },
  { label: '13.2.2', value: '13.2.2' },
  { label: '13.2.3', value: '13.2.3' },
  { label: '13.3', value: '13.3' },
  { label: '13.4', value: '13.4' },
  { label: '13.4.1', value: '13.4.1' },
  { label: '13.4.5', value: '13.4.5' },
  { label: '13.5', value: '13.5' },
  { label: '13.6', value: '13.6' },
  { label: '13.7', value: '13.7' },
  { label: '14.0', value: '14.0' },
  { label: '14.1', value: '14.1' },
  { label: '14.2', value: '14.2' },
  { label: '14.2.1', value: '14.2.1' },
  { label: '14.3', value: '14.3' },
  { label: '14.4', value: '14.4' },
  { label: '14.4.1', value: '14.4.1' },
  { label: '14.4.2', value: '14.4.2' },
  { label: '14.5', value: '14.5' },
  { label: '14.5.1', value: '14.5.1' },
  { label: '14.6', value: '14.6' },
  { label: '14.7', value: '14.7' },
  { label: '14.7.1', value: '14.7.1' },
  { label: '14.8', value: '14.8' },
  { label: '15.0', value: '15.0' },
  { label: '16.0', value: '16.0' },
  { label: '16.0.2', value: '16.0.2' },
  { label: '16.1', value: '16.1' },
  { label: '16.2', value: '16.2' },
  { label: '16.3', value: '16.3' },
  { label: '16.4', value: '16.4' },
  { label: '16.5', value: '16.5' },
  { label: '16.6', value: '16.6' },
  { label: '16.7', value: '16.7' },
  { label: '17.0', value: '17.0' },
  { label: '17.1', value: '17.1' },
  { label: '17.2', value: '17.2' },
  { label: '17.2.1', value: '17.2.1' },
  { label: '17.3', value: '17.3' },
  { label: '17.3.1', value: '17.3.1' },
  { label: '17.4', value: '17.4' },
  { label: '17.4.1', value: '17.4.1' },
  { label: '17.5', value: '17.5' },
  { label: '17.5.1', value: '17.5.1' },
  { label: '17.6', value: '17.6' },
  { label: '17.6.1', value: '17.6.1' },
  { label: '17.7', value: '17.7' },
  { label: '17.7.1', value: '17.7.1' },
  { label: '17.7.2', value: '17.7.2' },
  { label: '18.0', value: '18.0' },
  { label: '18.0.1', value: '18.0.1' },
  { label: '18.1', value: '18.1' },
  { label: '18.1.1', value: '18.1.1' },
  { label: '18.2', value: '18.2' },
  { label: '18.2.1', value: '18.2.1' },
  { label: '18.3', value: '18.3' },
  { label: '18.3.1', value: '18.3.1' },
  { label: '18.3.2', value: '18.3.2' },
  { label: '18.4', value: '18.4' },
  { label: '18.5', value: '18.5' },
];
